import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface StaffProfileBasicInfo {
  staffImage: string | null;
  staffName: string;
  designation: string;
  employmentId: string;
  dateOfBirth: string | null;
  dateOfJoining: string | null; // may be the sentinel "0000-00-00"
  gender: string;
  mobileNumber: string;
  emailId: string;
  address: string;
}

export interface StaffDayScheduleEntry {
  [key: string]: any;
}

export interface StaffTeachingClass {
  classNumber: string;
  classDivision: string;
  subject: string;
}

// Raw legacy-layer response — no {status, body} envelope.
export interface GetTeacherInfoResponse {
  profile: StaffProfileBasicInfo;
  classTeacherFor: any[];
  staffDaySchedule: StaffDayScheduleEntry[];
  teachingClassesAndSubjects: StaffTeachingClass[];
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class StaffProfileService {
  private url = AppSettings.API_ENDPOINT_STAFF_BASE;
  private getTeacherInfoEndpoint = apiConstants.getTeacherInfo;

  constructor(private http: HttpClient) {}

  getTeacherInfo(staffId: number | string) {
    return this.http
      .post<GetTeacherInfoResponse>(`${this.url}${this.getTeacherInfoEndpoint}`, { staffId: String(staffId) })
      .pipe(map((res) => res));
  }
}
